// extracted by mini-css-extract-plugin
export default {"wrap":"Progress_wrap__5aYXe","steps":"Progress_steps__ewB6g","step":"Progress_step__xLgm9","active":"Progress_active__CEgMX"};